module.exports = __webpack_public_path__ + "static/media/22.5129260d.jpg";